import { eq } from "drizzle-orm";
import {
  boolean,
  index,
  integer,
  pgTable,
  serial,
  text,
  timestamp,
  uniqueIndex,
} from "drizzle-orm/pg-core";
import { createSchemaFactory } from "drizzle-zod";
import { z } from "zod";

import { users } from "./auth";
import { timestamps } from "./shared";
import { tournaments } from "./tournaments";

const { createInsertSchema, createSelectSchema } = createSchemaFactory({
  zodInstance: z,
});

export const tournamentGalleryPhotos = pgTable(
  "tournament_gallery_photos",
  {
    id: serial().primaryKey(),
    tournamentId: integer()
      .notNull()
      .references(() => tournaments.id, { onDelete: "cascade" }),
    storagePath: text().notNull(),
    filename: text().notNull(),
    fileSize: integer(),
    caption: text(),
    photographer: text(),
    divisionTags: integer().array().notNull().default([]),
    approved: boolean().notNull().default(false),
    approvedAt: timestamp(),
    approvedBy: text().references(() => users.id),
    uploadedBy: text()
      .notNull()
      .references(() => users.id),
    sortOrder: integer().notNull().default(0),
    isCover: boolean().notNull().default(false),
    ...timestamps,
  },
  (table) => [
    index("gallery_photos_tournament_idx").on(table.tournamentId),
    index("gallery_photos_approved_idx").on(table.tournamentId, table.approved),
    uniqueIndex("gallery_photos_cover_idx")
      .on(table.tournamentId)
      .where(eq(table.isCover, true)),
  ],
);

export const selectTournamentGalleryPhotoSchema = createSelectSchema(
  tournamentGalleryPhotos,
);
export const createTournamentGalleryPhotoSchema = createInsertSchema(
  tournamentGalleryPhotos,
).omit({ id: true });

export type TournamentGalleryPhoto = z.infer<
  typeof selectTournamentGalleryPhotoSchema
>;
